<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else-if="!$can('access', 'MoleculeEditionAcademyAutoresponders')"
    key="accessDenied"
  >
    <p class="font-weight-bold text-color-danger">
      {{ $t('mEditionAcademyAutoresponders.accessDenied.firstText') }}
      <router-link
        :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myPayments.subject')}/${$t('mEditionMenu.billing.myPayments.children.changePlan.subedition')}`"
        class="text-link-hover-academy"
      >
        <i class="fas fa-link font-size-small"></i>
        {{ $t('mEditionAcademyAutoresponders.accessDenied.linkText') }}
      </router-link>
    </p>
  </div>
  <div
    v-else
    key="academyAutoresponders"
  >
    <h3>{{ $t('mEditionAcademyAutoresponders.title.first') }}</h3>
    <div class="m-list-integrations m-list-integrations-separate">
      <article
        v-for="autoresponder in autoresponders"
        :key="autoresponder.id"
        class="m-card-primary m-card-transition m-list-integrations-item"
        @click.prevent="selectAutoresponder(autoresponder)"
      >
        <div class="m-list-integrations-item-actions m-list-integrations-item-actions-academy">
          <span>{{ $t('mEditionAcademyAutoresponders.action') }}</span>
        </div>
        <img
          alt="autoresponder.nombre"
          :src="autoresponder.imagen ? autoresponder.imagen : '@/assets/img/payment.png'"
        >
        <h5>{{ autoresponder.nombre }}</h5>
      </article>
    </div>

    <h3 v-if="academiaAutoresponders.length > 0">
      {{ $t('mEditionAcademyAutoresponders.title.second') }}
    </h3>
    <div
      v-if="academiaAutoresponders.length > 0"
      class="margin-top-xxlarge m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionAcademyAutoresponders.table.thAccount') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionAcademyAutoresponders.table.thAutoresponder') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionAcademyAutoresponders.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="autoresponder in academiaAutoresponders"
          :key="autoresponder.id_academia_autoresponder"
          class="row-data"
        >
          <td class="display-flex-row-center text-align-left">
            <img
              alt="autoresponder.descripcion"
              class="border-radius-medium margin-right-small width-60-px"
              :src="autoresponder.autoresponder.imagen ? autoresponder.autoresponder.imagen : '@/assets/img/payment.png'"
            >
            {{ autoresponder.descripcion }}
          </td>
          <td class="text-align-center">
            {{ autoresponder.autoresponder.nombre }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="autoresponder"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyAutoresponders',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaAutoresponders: [],
      academiaId: '',
      autoresponders: [],

      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionAcademyAutorespondersModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionAcademyAutoresponders.tooltip.delete'),
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      showLoadingState: 0
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readAcademiaAutoresponders()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readAcademiaAutoresponders()
    this.readAutoresponders()
  },

  methods: {
    readAcademiaAutoresponders () {
      this.$services.read('academia', 'readAcademiaAutoresponders', {}, [this.academiaId])
        .then(response => {
          console.log(response.data)
          this.academiaAutoresponders = response.data
          this.pagination.currentQuantity = this.academiaAutoresponders.length
          this.pagination.totalQuantity = this.academiaAutoresponders.length
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readAutoresponders () {
      this.$services.read('autoresponder', 'readAutoresponders')
        .then(response => {
          this.autoresponders = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    selectAutoresponder (autoresponder) {
      this.$store.commit('setAcademyAutoresponder', autoresponder)
      this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.autoresponders.subject')}/${this.$t('mEditionMenu.academy.autoresponders.children.connectAutoresponder.subedition')}`)
    }
  }
}
</script>
